const HEADER = [
  "// Auto-generated from this profile's Schema. Fill in the TODOs below.",
  "//",
  "// REQUIRED OUTPUT SHAPE: this function MUST return an Array of",
  "//   { channel, type, value, unit }",
  "// objects. Vendor code that returns { data: { ... } } will NOT work — the",
  "// platform silently drops metrics with the wrong shape on real ingest.",
  "//",
  "// How this works:",
  "//   1. The switch below parses each TLV record into a flat `data` object.",
  "//   2. The return statement maps `data` onto the array shape your contract requires.",
  "//",
  "// The {channel, type, unit} fields in the return array are locked to your schema.",
  "// Don't edit them. Only fill in:",
  "//   - case 0x0000 — replace with the wire data ID your sensor uses",
  "//   - the reader fn — swap readInt16BE/readUInt16BE/etc. for the right byte size & signedness",
  "//   - scaling — add `/ 10`, `/ 100`, etc. if the wire value is scaled",
  "",
].join("\n");

const PRELUDE = `function decode(fPort, buffer, json) {
  const data = {};
  let i = 0;

  function readUInt16BE(offset) {
    return (buffer[offset] << 8) | buffer[offset + 1];
  }

  function readInt16BE(offset) {
    let val = (buffer[offset] << 8) | buffer[offset + 1];
    if (val & 0x8000) val -= 0x10000;
    return val;
  }

  while (i < buffer.length) {
    const dataId = readUInt16BE(i);
    i += 2;

    const dataLen = buffer[i];
    i += 1;

    switch (dataId) {
`;

const POSTLUDE_OPEN = `      default:
        break;
    }

    i += dataLen;
  }

  return [
`;

const POSTLUDE_CLOSE = `  ];
}
`;

// Escape for embedding inside a single-quoted JS string literal.
const escSQ = (s) => String(s ?? "").replace(/\\/g, "\\\\").replace(/'/g, "\\'");

// Strip newlines/CRs for embedding in a `//` comment, which cannot span lines.
const escComment = (s) => String(s ?? "").replace(/[\r\n]+/g, " ");

// Coerce arbitrary text into a valid JS identifier so we can use dot-notation
// on the `data` accumulator. Non-identifier chars become `_`; a leading digit
// is prefixed with `_`; an empty result becomes `_`.
const toIdent = (s) => {
  const slug = String(s ?? "").replace(/[^A-Za-z0-9_$]/g, "_");
  if (!slug) return "_";
  return /^[0-9]/.test(slug) ? `_${slug}` : slug;
};

// `case 0x0000:` is intentional — duplicates trigger a JS warning that nudges
// the user to fill in real data IDs. Don't dedupe.
const renderCase = (cap) => {
  const key = toIdent(cap.type);
  const rawLabel = cap.name || cap.type || `channel ${cap.channel ?? ""}`;
  const label = escComment(rawLabel);
  return (
    `      case 0x0000: // TODO: data ID for "${label}"\n` +
    `        data.${key} = readInt16BE(i);\n` +
    `        break;\n` +
    `\n`
  );
};

const renderReturnEntry = (cap) => {
  const channel = escSQ(cap.channel);
  const type = escSQ(cap.type);
  const unit = escSQ(cap.unit);
  const key = toIdent(cap.type);
  return `    { channel: '${channel}', type: '${type}', value: data.${key}, unit: '${unit}' },\n`;
};

/**
 * Generate a TLV-style decoder scaffold from a profile's saved capabilities.
 * The {channel, type, unit} triple in each return-array entry is locked to
 * the schema; the data ID, reader function, and scaling are TODOs the user
 * fills in.
 *
 * @param {Array<{channel: string|number, name?: string, type: string, unit?: string, min?: number, max?: number}>} capabilities
 * @returns {string} JavaScript source for the decode() function
 */
export function generateFromSchema(capabilities) {
  const caps = capabilities || [];
  const cases = caps.map(renderCase).join("");
  const returnEntries = caps.map(renderReturnEntry).join("");
  return HEADER + PRELUDE + cases + POSTLUDE_OPEN + returnEntries + POSTLUDE_CLOSE;
}
